import features from '@common/constants/features';

export default {
  namespaced: true,

  state: () => ({
    status: 200, // ставим на ssr этот статус для 404
    abTestTextAddCart: true,
    ip: '',
    accessToken: '',
    ostinAccessToken: '',
  }),

  getters: {
    status: (state) => state.status,
    abTestTextAddCart: (state) => state.abTestTextAddCart,
    accessToken: (state) => state.accessToken,
    ostinAccessToken: (state) => state.ostinAccessToken,
  },

  actions: {
    async loadABTest({ commit, rootGetters }) {
      try {
        const defaultValue = { textAddCart: true };
        const abTest = rootGetters['features/$isFeatureEnabled'](features.ABTEST_FUNDAY_TEST_G1) === false ? defaultValue : await this.$apiBFF.getAbTest();
        commit('setABTestTextAddCart', abTest.textAddCart);
      } catch (e) {
        commit('setABTestTextAddCart', true);
      }
    },

    async updateAccessToken({ commit }) {
      const { token } = await this.$apiBFF.fetchAccessToken();
      const [, body] = token.split('.');
      const { osT = '' } = JSON.parse(atob(body)) ?? {};

      commit('setAccessToken', token);
      commit('setOstinAccessToken', osT);
    },
  },

  mutations: {
    setStatus: (state, status = 200) => {
      state.status = status;
    },
    setABTestTextAddCart: (state, abTestTextAddCart) => {
      state.abTestTextAddCart = abTestTextAddCart;
    },
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setOstinAccessToken(state, token) {
      state.ostinAccessToken = token;
    },
  },
};
